import React, { useMemo } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow } from '@coreui/react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectInsightsData } from '../../../store/selectors/insights.selectors';
import weekdaysFormater from '../../helpers/week-days.helper';
import DailyVolumeChart from '../widgets/DailyVolumeChart';
import { JobPhase } from '../../../shared/models/jobs';

const DailyPhaseVolume = () => {
  const history = useHistory();
  const data = useSelector(selectInsightsData);

  const computedData = useMemo(() => {
    return weekdaysFormater(data?.tasks);
  }, [data?.tasks]);

  const clickHandler = (rowData) => {
    history.push(`/insights/tasks/${rowData.id}`);
  }

  return (
    <CRow>
      <CCol md={12}>
        <CCard className="glympser-container--roundedWithShadow">
          <CCardHeader className="border-0 glympser-roundedTop">
            Average Daily Volume
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={12} style={{height: '400px'}}>
                <DailyVolumeChart
                  keys={[JobPhase.Completed, JobPhase.Cancelled]}
                  indexBy='day'
                  onClick={clickHandler}
                  data={computedData}
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default DailyPhaseVolume;
